<div>
  <app-header></app-header>
  <app-horizontal-nav-tab [links]="[null,null]" [titles]="['Dashboard 1', 'Dashboard 2']">
  </app-horizontal-nav-tab>
</div>
<app-project-dashboard2 ></app-project-dashboard2>
